import { createRoot } from "react-dom/client";
import { AuthProvider } from "./context/AuthContext";
import App from "./App";

/* Phones draw the whole UI at 85%. An initial-scale under 1 beside width=device-width makes the browser
   lay out a viewport 1/0.85 wider and draw it scaled down, so every length, viewport unit, media query
   and measured rect stays consistent (a CSS zoom would scale 100dvh too and leave a band at the bottom).
   Decided by the device's short side so rotation doesn't flip it. Done here, not inline in index.html,
   because the CSP allows no inline scripts. On iOS the matching maximum-scale stops Safari zooming in on
   a focused field; iOS still lets people pinch-zoom, and Android keeps pinch by not getting the cap. */
const PHONE_SCALE = 0.85;
const PHONE_SHORT_SIDE_MAX = 767;
(() => {
  if (typeof window === "undefined" || !window.screen) return;
  const shortSide = Math.min(window.screen.width, window.screen.height);
  if (!(shortSide > 0 && shortSide <= PHONE_SHORT_SIDE_MAX)) return;
  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;
  const ios = /iPhone|iPad|iPod/.test(navigator.userAgent);
  meta.setAttribute(
    "content",
    `width=device-width, initial-scale=${PHONE_SCALE}${ios ? `, maximum-scale=${PHONE_SCALE}` : ""}`,
  );
})();

const root = createRoot(document.getElementById("root"));

root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
